module.exports = __webpack_public_path__ + "static/cosycolour2-e799de6e52b0312da26defe6c366b9f9.png";